<!--add some space so footer never overlaps anything-->
<div style="height: 150px"></div>
<footer class="text-center text-lg-start bg-light text-muted">
  <div class="bottom-footer" style="background-color: rgb(243,243,243);">
    <div class="d-flex flex-column flex-md-row justify-content-center gap-2 align-content-center">
      <div class="mt-1 ms-md-5" >
        © {{ currYear }} Copyright:
        <a class="text-reset fw-bold" href="https://www.regioit.de/">regio iT</a>
        Gesellschaft für Informationstechnologie mbH
      </div>
      <div class="mt-1 ms-md-5" >
        <a class="text-reset fw-bold" style="text-decoration:none; cursor:pointer;" [routerLink]="['/information/attribution']"
           data-cy="nav-item-attribution">{{'STANDARD.ATTRIBUTION'|translate}}
        </a>
      </div>
      <div class="mt-1 ms-md-5">
        <a class="text-reset fw-bold" style=text-decoration:none [routerLink]="['/pages/home']"
           data-cy="nav-item-home">{{'APPLICATION.NAVBAR.HOME'|translate}}</a>
      </div>
      <div class="mt-1 ms-md-5">
        <a  class="text-reset fw-bold" style="text-decoration:none; cursor:pointer;" (click)="navigateToImpressum()"
            data-cy="nav-item-impressum">{{'APPLICATION.FOOTER.IMPRESSUM'|translate}}
        </a>
      </div>
      <div class="mt-1 ms-md-5 me-md-5" >
        <a class="text-reset fw-bold" style="text-decoration:none; cursor:pointer;" (click)="navigateToDatenschutz()"
           data-cy="nav-item-datenschutz">{{'APPLICATION.FOOTER.DATENSCHUTZ'|translate}}</a>
      </div>
    </div>
  </div>
  <!-- Show version but hidden in HTML -->
  <div class="p-2" style="display: none">
    {{'APPLICATION.FOOTER.VERSION'|translate}}: {{version}}
  </div>
</footer>
